import { useURequestRaw } from '@newageerp/v3.bundles.hooks-bundle'
import React, { Fragment, useEffect } from 'react'

import { XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { LogoLoader } from '@newageerp/v3.bundles.layout-bundle';

export default function Disputes() {
  const [doReq, doReqParams] = useURequestRaw<any>("/app/plugins/StripeDispute/reports");

  const loadData = () => {
    doReq({});
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      {doReqParams.loading && <LogoLoader />}
      {!!doReqParams.data && !!doReqParams.data.data &&
        <ResponsiveContainer width="100%" height={450}>
          <BarChart width={600} height={450} data={doReqParams.data.data}>
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar type="monotone" dataKey="all" fill="#DA2727" stackId="1" />
          </BarChart>
        </ResponsiveContainer>
      }
    </Fragment>
  )
}
